import { render, staticRenderFns } from "./MeasurementsView.vue?vue&type=template&id=3a1a65c2&lang=pug&"
import script from "./MeasurementsView.vue?vue&type=script&lang=ts&"
export * from "./MeasurementsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports